import { Injectable } from "@angular/core";

/**
 * 半角カンマ区切りに金額をフォーマットするサービス
 * @export
 * @class MoneyFormatService
 */
@Injectable({
  providedIn: 'root'
})
export class MoneyFormatService {

  constructor() { }

  /**
   * 金額フォーマット（カンマ付与）
   * @param value 
   * @returns カンマを付与した金額
   */
  public formatMoney(value: string): string {

    if (value === '' || value === null) {
      return '';
    }

    // 整数部分と小数部分に分割
    const parts = value.split('.');;
    // 整数部分にカンマを挿入
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // 整数部分と小数部分を結合して返す
    return parts.join('.');
  }

  /**
   * 金額フォーマット（カンマ除去）
   * @param value 
   * @returns カンマを除去した金額
   */
  public reformatMoney(value: string): string {
    
    // 引数が null、空白文字列（スペースのみ含む）、数値以外の場合は null を返却
    if (value === null || value.trim() === '' || isNaN(Number(value.replace(/,/g, '')))) {
      return null;
    }

    // カンマを除去して返却
    return value.replace(/,/g, '');
  }
}
